import React, { useEffect, useRef, useState } from 'react';

// ─── TAB BAR ──────────────────────────────────────────────────────────────────
// Shared tab row. tabs: [{ id, label }], value: active id.
// Replaces the hand-rolled .tab-bar markup previously copied per screen.

export default function TabBar({ tabs = [], value, onChange, style }) {
  const rowRef = useRef(null);
  // Row scrolls horizontally when tabs overflow (see .tab-bar's overflow-x),
  // but with no visible scrollbar there's otherwise zero hint more tabs exist
  // off-screen. Only fade the trailing edge when there's actually something
  // to scroll to — a short tab list that already fills the row via flex-grow
  // would otherwise get a fade for no reason.
  const [scrollable, setScrollable] = useState(false);

  useEffect(() => {
    const el = rowRef.current;
    if (!el) return;
    const check = () => setScrollable(el.scrollWidth > el.clientWidth + 1);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [tabs]);

  return (
    <div ref={rowRef} className={`tab-bar${scrollable ? ' tab-bar--scrollable' : ''}`} role="tablist" style={style}>
      {tabs.map(t => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={value === t.id}
          className={`tab-btn ${value === t.id ? 'tab-btn--active' : ''}`}
          onClick={() => onChange?.(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
